export * from './count.directive';
export * from './count.helper';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/common/count/index.js
// module id = ../../../../@swimlane/ngx-charts/release/common/count/index.js
// module chunks = 4